module.exports = __webpack_public_path__ + "Neeko.1b9bd6ec.png";